<template>
  <div class="download">
    <banner :img="imgurl" title="群团工作" />


 <div class="radionstyle">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/download">党建概况</el-menu-item>
            <el-menu-item index="/DownloadOne">党建工作</el-menu-item>
            <el-menu-item index="/DownloadTwo">群团工作</el-menu-item>
          </el-menu>
        </div>



  <div class="djtitle" v-for="(item,index) in tableData" :key="index" @click="ServiceClick(item.id)"> 
     <div class="titlecontext" >
            <div class="titleTop">{{item.title}}</div>
            <div class="titleTime">{{item.createTime  |dateFormat}}</div>
            <div class="titleText">{{item.content}}</div>
     </div>
  </div>

  <!-- <div class="djfooter">
   
    
  </div> -->




  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      router: true,
      defaultActive: "/",
      imgurl: require("../assets/img/list_bg.png"),
      tableData:[],
        serviceList: [
                {
                    id: 'section-1',
                    title: '鹤煤中泰矿业 携手奋进促生产',
                    time: '2022-03-11',
                    text: "用真情唤起职工的安全意识。共同构筑安全生产防线。能帮我订个扣子吗。……刚上井的工人师傅们围在井口缝补站。女工协管员们耐心、热心地回复着每一位工人师傅。",
                },{
                    id: 'section-2',
                    title: '新疆龟兹矿业 “两癌”筛查暖人心',
                    time: '2022-03-11',
                    text: "为该矿60余名女职工开展。两癌。免费筛查。为女职工撑起健康。筛查是指宫颈癌筛查和乳腺癌筛查。准确地将乳腺癌和宫颈癌检查出来。使适龄妇女对自身健康有一个全面准确的认知。",
              
                },{
                    id: 'section-3',
                    title: '永煤铁运处 促青工快速成才',
                    time: '2022-02-16',
                    text: "该处在月度培训中设立班组、站段、处三级课堂。并在处、站段课堂上由特长职工进行知识讲解。该处在新入职大学生职工中选拔人员进行内燃机车副司机、司机技能培养。做好人才储备。"
                },{
                    id: 'section-4',
                    title: '焦煤赵固一矿 让雷锋精神在岗位上闪光',
                    time: '2021-09-30',
                    text: "该矿团委组织青年志愿者开展了。青年志愿者奉献活动。组织青年志愿者义务打扫矿区环境、清除卫生死角。该矿团委把开展青年志愿者学雷锋活动与创建。"
                }
            ]
    };
  },
   methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
     ServiceClick(id){
            this.$router.push({
                name: 'downloadTwoDetail',
                params: {
                    id: id
                }
            })
        },
            loadData() {
      this.loading = true;
      this.$http
        .get(`News/Search?type=4&count=6`)
        .then(response => {
           window.console.log(response.data.result);
          if(response.status==200){
            if(response.data.result.length!=0){
              this.tableData = response.data.result;
              this.loading = false;
            }
          }
         
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },
  },
     mounted() {
    this.loadData();
  },
 
};
</script>

<style lang="scss" scoped>
.radionstyle{

  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
}
.el-radionstyle-demo {
  background-color: rgb(163, 172, 166);
  opacity: 0.4;
}



.djtitle{

  align-content: center;
  height: auto;
   width: 1240px;

  justify-content: stretch;
   margin: 0 auto;
   display: flex;

   .titlecontext{
       margin-bottom: 20px;
    
       background-color: #F6F7F9;
        padding-left: 20px;
  height: 150px;
     width: 1240px;

   }
   .titleTop{
    color: #000;
    font-size: 18px;
    line-height: 24px;
    text-align: left;
   }
   .titleTime{
    display: block;
    font-size: 14px;
    color: #999;
   
    margin-top: 8px;
    line-height: 24px;
   }
   .titleText{
            white-space: nowrap; 
    text-overflow:ellipsis; 
    overflow:hidden; 
       margin-top: 14px;
    color: #666;
    line-height: 24px;
    text-indent: 2em;
   }
}





.djfooter{
   align-content: center;
   height: 650px;
   width: 99.9%;
   
   justify-content: stretch;
   margin: 0 auto;
 
   background-color: #eee;
   .footertitle{
       padding-top: 10px;
text-align: center;
margin-right: 1000px;
   }
   .footerimg{
     margin-top: 40px;
     text-align: center;
padding-right: 0px;
   }
}

</style>
